import React from 'react';
import { MessageCircleIcon, ZapIcon, HeartIcon, SparklesIcon, StarIcon, FlameIcon } from 'lucide-react';
import { motion } from 'framer-motion';
export function MessageTypesSection() {
  const types = [{
    text: <span key="1" data-id="element-171">
          Mensajes para <strong data-id="element-172">iniciar conversación</strong> con impacto
        </span>,
    icon: ZapIcon
  }, {
    text: <span key="2" data-id="element-173">
          Mensajes que generan <strong data-id="element-174">atracción inmediata</strong>
        </span>,
    icon: FlameIcon
  }, {
    text: <span key="3" data-id="element-175">
          Mensajes para <em data-id="element-176">cuando se enfría</em>
        </span>,
    icon: HeartIcon
  }, {
    text: <span key="4" data-id="element-177">
          Mensajes que lo hacen <strong data-id="element-178">invertir emocionalmente</strong>
        </span>,
    icon: MessageCircleIcon
  }, {
    text: <span key="5" data-id="element-179">
          Mensajes que te posicionan como <strong data-id="element-180">prioridad</strong>
        </span>,
    icon: StarIcon
  }, {
    text: <span key="6" data-id="element-181">
          Mensajes que despiertan <em data-id="element-182">curiosidad y deseo</em>
        </span>,
    icon: SparklesIcon
  }];
  return <section className="py-12 md:py-16 bg-[#1f1f35]" data-id="element-183">
      <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-184">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-10" data-id="element-185">
          <h2 className="text-3xl xl:md:text-4xl font-bold text-white mb-4" data-id="element-186">
            Tipos de Mensajes Que Aprenderás Hoy
          </h2>
          <div className="w-24 h-1 bg-gold-500 mx-auto rounded-full" data-id="element-187" />
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-188">
          {types.map((type, index) => {
          const Icon = type.icon;
          return <motion.div key={index} initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: index * 0.1
          }} className="bg-white/5 p-6 rounded-2xl border border-white/10 flex items-center space-x-4 hover:bg-white/10 hover:-translate-y-1 transition-all duration-300" data-id="element-189">
                <div className="w-12 h-12 rounded-full bg-rose-500/20 flex items-center justify-center flex-shrink-0" data-id="element-190">
                  <Icon className="w-6 h-6 text-rose-400" data-id="element-191" />
                </div>
                <p className="text-lg font-medium text-gray-200" data-id="element-192">{type.text}</p>
              </motion.div>;
        })}
        </div>

        <motion.div initial={{
        opacity: 0,
        scale: 0.9
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} className="mt-10 text-center" data-id="element-193">
          <span className="inline-block px-8 py-3 bg-gold-500/10 text-gold-400 font-bold text-xl rounded-full border border-gold-500/30 shadow-sm" data-id="element-194">
            Y mucho más!
          </span>
        </motion.div>
      </div>
    </section>;
}